export default "__VITE_ASSET__CI7Zmkb9__"